import { render, staticRenderFns } from "./UserProjectPermissionAssignment.vue?vue&type=template&id=161ebaee"
import script from "./UserProjectPermissionAssignment.vue?vue&type=script&lang=js"
export * from "./UserProjectPermissionAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports